import React from 'react'

import { AppContext } from '@/components/base/appcontext'
import { Skeleton } from '@/components/ui/skeleton'

/**
 * The programme details page while it loads, in its own layout: title and
 * author photo, description, badges, the four-figure strip, exercise rows.
 * The content lands where the placeholders were instead of replacing a
 * generic stack of bars.
 */
export function DetailsSkeleton() {
    const appContext = React.useContext(AppContext)
    return (
        <div role="status" className="flex flex-col gap-5">
            <span className="sr-only">{appContext.geti18n('Loading...')}</span>
            <div className="flex items-start gap-3">
                <div className="flex flex-1 flex-col gap-2">
                    <Skeleton className="h-6 w-3/4 rounded-md" />
                    <Skeleton className="h-6 w-1/2 rounded-md" />
                </div>
                <Skeleton className="h-10 w-10 shrink-0 rounded-full" />
            </div>
            <div className="flex flex-col gap-2 pl-3">
                <Skeleton className="h-4 w-full rounded-md" />
                <Skeleton className="h-4 w-11/12 rounded-md" />
                <Skeleton className="h-4 w-2/3 rounded-md" />
            </div>
            <div className="flex gap-1.5">
                <Skeleton className="h-5 w-20 rounded-full" />
                <Skeleton className="h-5 w-16 rounded-full" />
                <Skeleton className="h-5 w-24 rounded-full" />
            </div>
            <div className="grid grid-cols-4 gap-1 py-2 border-y border-border/50">
                {Array.from({ length: 4 }, (_, i) => (
                    <div key={i} className="flex flex-col items-center gap-1.5">
                        <Skeleton className="h-3.5 w-3.5 rounded-sm" />
                        <Skeleton className="h-4 w-8 rounded-md" />
                    </div>
                ))}
            </div>
            <div className="flex flex-col gap-3 pt-1">
                {Array.from({ length: 5 }, (_, i) => (
                    <div
                        key={i}
                        style={{ opacity: 1 - i * 0.15 }}
                        className="flex items-center justify-between gap-2"
                    >
                        <Skeleton className="h-4 w-2/5 rounded-md" />
                        <div className="flex gap-1">
                            <Skeleton className="h-7 w-7 rounded-full" />
                            <Skeleton className="h-7 w-7 rounded-full" />
                            <Skeleton className="h-7 w-7 rounded-full" />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}
